/**
 * Whether a kiosk flow may go on with a booking it just found.
 *
 * Shared by the check-in hub, which runs every lookup, and the start screen,
 * which looks up the pre-registered QR code itself before leaving: a code that
 * cannot go anywhere is answered right where it was scanned, instead of
 * sending the guest to a hub that would only show them the same refusal.
 */
import { booking_status } from '../../../utils/mockup';
import { KIOSK_FLOWS } from './kiosk_config';

export const CHECKED_OUT_STATUS_IDS = [
    booking_status.checked_out,
    booking_status.ready_to_pay_checkout,
    booking_status.checkout_completed,
    booking_status.check_out_hold,
    booking_status.check_out_payment,
    booking_status.check_out_completed_by_system,
];

// Why `flow` cannot go on with this booking — `{ info }` for a "nothing to do"
// outcome, `{ error }` for a refusal, each an i18n key — or null when it can.
// `group` is the message group naming what the guest searched with
// ('checkin_by_qr', 'checkin_by_phone', ...), so the notice matches the
// button they pressed.
//
// Checked-in and checked-out bookings are refused by every flow: the API will
// not re-check-in a booking (CheckinRepository@logBooking rejects both
// statuses), so letting the guest fill a whole form first would only fail at
// the end. Confirm Pre Check-in only finishes PRE CHECK-IN bookings; Start Pre
// Check-in has nothing left to do with one.
export function kioskFlowRejection(booking, flow, group) {
    const status = booking?.booking_status_id;

    if (status === booking_status.checked_in) {
        return { info: `${group}.info_already_checkedin` };
    }

    if (CHECKED_OUT_STATUS_IDS.includes(status)) {
        return { error: `${group}.error_already_checkedout` };
    }

    const isPreCheckedIn = status === booking_status.pre_check_in;

    if (flow === KIOSK_FLOWS.CONFIRM_PRE_CHECKIN && !isPreCheckedIn) {
        return { error: 'virtual_kiosk.error_not_pre_checkedin' };
    }

    if (flow === KIOSK_FLOWS.START_PRE_CHECKIN && isPreCheckedIn) {
        return { info: `${group}.info_pci_already_completed` };
    }

    return null;
}
